// get base path
const elementData = document?.querySelector('powertrip-powersell')
const passedBackendPath =
  elementData?.attributes?.['backend' as any]?.nodeValue // this version of ts has issue typing dom objects correctly hence the any.
const backendParts = passedBackendPath?.split('.') // splits "https://sandbox.gameplan.powertrip.earth" to ["https://sandbox","gameplan","powertrip", "earth"]
const extrapolatedFrontendPath = backendParts
  ? `${backendParts[0]}.powersell.powertrip.earth/img/`
  : undefined

// asset base urls for use with getting images while an embedded web component.
const devAssetUrl = 'http://localhost:8080/img/'
const prodAssetUrl =
  window.location.hostname === 'powersell.powertrip.earth' ||
  window.location.hostname === 'staging.powersell.powertrip.earth'
    ? `https://${window.location.hostname}/img/`
    : (extrapolatedFrontendPath ?? 'https://staging.powersell.powertrip.earth/img/')

const baseAssetUrl = import.meta.env.MODE === 'development' ? devAssetUrl : prodAssetUrl

export default function getAssetSrc(assetFileName: string): string {
  return baseAssetUrl + assetFileName
}
